import type { Text } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import { asText, readString } from '../utils';

export const date = (node: PMNode): Text | null => {
	const timestamp = readString(node.attrs.timestamp);
	if (!timestamp) {
		return null;
	}
	const parsed = new Date(Number(timestamp));
	return asText(Number.isNaN(parsed.getTime()) ? undefined : parsed.toISOString().slice(0, 10));
};
